import { createTheme } from '@mui/material';

import palette from './palette';
import components from './components';
import mixins from './mixins';
import typography from './typography';

const theme = {
  breakpoints: {
    // todo sync it
    values: {
      xs: 0,
      sm: 420,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
  typography,
  palette,
  components,
  mixins,
};

export default createTheme(theme);
